import { Option } from 'react-multi-select-component/dist/types/lib/interfaces';

export const removeKey =
  (k: string) =>
  (oldValue: Record<string, number>): Record<string, number> => {
    const newObj = Object.assign({}, oldValue);
    delete newObj[k];
    return newObj;
  };

export const handleConceptSelection = (newSelectedConcepts: Option[]) => (oldValue: Record<string, number>) => {
  const conceptNames = newSelectedConcepts.map((option) => option.value);
  const newValue: Record<string, number> = {
    ...oldValue,
  };
  const keys = Object.keys(oldValue);
  conceptNames.forEach((concept: string) => {
    if (!keys.includes(concept)) {
      newValue[concept] = 0;
    }
  });
  keys.forEach((k) => {
    if (!conceptNames.includes(k)) {
      delete newValue[k];
    }
  });
  return newValue;
};
